import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { TimeZoneService } from '../../core/services/timezone.service';
import { Subscription } from 'rxjs';

/**
 * Pipe for formatting dates according to user's timezone
 * Usage: {{ dateValue | userDate:'format' }}
 * Supported formats: 'MM/dd/yyyy', 'dd/MM/yyyy', 'yyyy-MM-dd',
 * 'MM/dd/yyyy HH:mm', 'MM/dd/yyyy hh:mm a', 'short', 'full',
 * 'hh:mm a', 'HH:mm', 'h:mm a'
 */
@Pipe({
  name: 'userDate',
  standalone: true,
  pure: false,
})
export class UserDatePipe implements PipeTransform, OnDestroy {
  private cache = {
    value: null as Date | string | null,
    format: 'MM/dd/yyyy',
    result: '',
    timezone: null as string | null,
  };

  private subscription: Subscription;

  constructor(private timeZoneService: TimeZoneService) {
    this.subscription = this.timeZoneService.userTimeZone$.subscribe(
      timezone => {
        this.cache.timezone = timezone;
        this.cache.result = '';
      }
    );
  }

  transform(value: Date | string | null, format = 'MM/dd/yyyy'): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (
      value === this.cache.value &&
      format === this.cache.format &&
      this.cache.result !== ''
    ) {
      return this.cache.result;
    }

    this.cache.value = value;
    this.cache.format = format;

    try {
      let dateFormat = format;
      switch (format) {
        case 'short':
          dateFormat = 'MM/dd/yyyy';
          break;
        case 'full':
          dateFormat = 'MM/dd/yyyy hh:mm a';
          break;
        case 'hh:mm a':
        case 'HH:mm':
        case 'h:mm a':
          break;
      }

      this.cache.result = this.timeZoneService.formatDate(
        value,
        dateFormat,
        this.cache.timezone || undefined
      );
      return this.cache.result;
    } catch (error) {
      console.error('UserDatePipe error:', error);
      return '';
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
